import { useTranslation } from 'react-i18next'

import { HashIcon } from '@phosphor-icons/react'

import AnimatedNumber from '@/common/components/AnimatedNumber/AnimatedNumber'
import Statistic from '@/common/components/Statistic/Statistic'
import { viewIds } from '@/returns/pages/TransactionsPage/constants'

const CurrentMonthTransactions = ({ transactions, onClick }) => {
  const { t } = useTranslation()

  return (
    <Statistic
      size="small"
      isOutlined={false}
      Icon={HashIcon}
      label={t('Transacciones Últimos 30 días')}
      value={<AnimatedNumber target={transactions} format="decimal" />}
      onClick={() => onClick(viewIds.lastThirtyDays)}
    />
  )
}

export default CurrentMonthTransactions
